export const enNZ = {
  APP_TITLE: 'My SmartPayroll SignUp',
  FOOTER_DISCLAIMER: 'My SmartPayroll SignUp © 2020 All Rights Reserved',

  // Header
  HOME: 'Home',
  MENU: 'Menu',

  // Loading
  WEBSITE_IS_LOADING: 'Loading',

  // Error page
  404: '404',
  WHOOPS: 'Whoops.',
  PAGE_NOT_FOUND: 'Sorry the page you are looking for cannot be found.',
  BACK_TO_START: 'Visit start of Sign Up flow',
  SOMETHING_WENT_WRONG: 'Looks like something went wrong, try refreshing or come back later.',

  // Global
  GET_STARTED: 'Get started with SmartPayroll',
  REQUEST_CALLBACK: 'Request callback',
  LOADING: 'Loading...',
  CANNOT_LOAD_OPTIONS: 'Error, couldn\'t load options from server, please refresh your browser or try again later.',
  YES: 'Yes',
  NO: 'No',
  COUNT: 'Count: ',

  // Input placeholders
  AMOUNT: 'Amount',
  SELECT: 'Select',
  ENTER_FIRST_NAME: 'Enter first name',
  ENTER_LAST_NAME: 'Enter last name',
  EMAIL_EXAMPLE: 'E.g. jane.doe@gmail.com',
  ENTER_NUMBER: 'Enter number',
  NO_RESULTS: 'No results, try again or use the manual entry',
  PLEASE_SPECIFY_OPTIONAL: 'Please specify (optional)',
  PLEASE_SPECIFY: 'Please specify',
  ENTER_AMOUNT: 'Enter amount',
  BANK_NUMBER_PLACEHOLDER: 'bank - branch - account - suffix',
  ENTER_DETAILS_PLACEHOLDER: 'Enter details',
  BANK_PLACEHOLDER: 'Enter the bank name',

  // Buttons
  BUTTON_CANCEL: 'Cancel',
  BUTTON_NEXT: 'Next',
  BUTTON_BACK: 'Back',
  BUTTON_CONFIRM: 'Confirm',
  BUTTON_BACK_TO_SMART_PAYROLL: 'Back to SmartPayroll',
  BUTTON_CLEAR: 'Clear',

  // ==========
  // Flow steps
  // ==========

  // Work it out
  HOW_MANY_EMPLOYEES: 'How many employees do you have, and how often do you pay them?',
  EMPLOYEE_COUNT: 'Employee count',
  PAY_CYCLE: 'Pay cycle',
  ADD_PAY_CYCLE: 'Add additional pay cycle',
  ERROR_NO_PAY_RUN: 'Please add at least 1 pay run',
  ERROR_EMPLOYEE_COUNT: 'Please add the employee count',
  ERROR_MAX_EMPLOYEE_COUNT: 'You’ve entered a large amount of employees, contact our support team on 0800 10 10 38 to discuss your options',
  ERROR_PAY_CYCLE: 'Please add the pay cycle',

  MANAGE_PAY_CYCLES: 'How would you like to manage your payroll?',
  MANAGE_PAY_CYCLES_TEXT: 'We can help calculate payments, and automate employee and IRD payments',
  ERROR_MANAGE_PAY_CYCLES: 'Please select a pay cycle',

  MANAGE_HR_SERVICES: 'How do you manage your HR services? (Optional)',
  MANAGE_HR_SERVICES_TEXT: 'We can help with Performance Management, HR guides, Employee File Management and more.',

  WHO_DO_YOU_BANK_WITH: 'Who do you bank with?',
  BANK_WHY: 'This will determine what payroll support level we can offer you.',
  ERROR_WHO_DO_YOU_BANK_WITH: 'Please select who you bank with as this determines the available plans',
  BANK_OTHER: 'Please specify the bank',
  ERROR_BANK_OTHER: 'Please specify the bank as this can determine the available plans',

  // Right column (pricing component)
  IT_TAKES_A_MINUTE: 'It just takes a minute',
  ENTER_DETAILS: 'Enter your details and we will find a plan for you.',
  YOUR_PLAN: 'Your plan',
  AVERAGE_FEES_PER_MONTH: 'SmartPayroll average fees per month',
  PLEASE_SELECT_A_PLAN: 'Please select a plan',
  ARE_YOU_REGISTERED_CHARITY: 'Are you a registered charity?',
  MONTHLY_BASE_FEE: 'Monthly base fee',
  PRICE_PER_EMPLOYEE: 'Price per employee pay per cycle',
  PAY_RUN_FOR: 'pay run for',
  TOTAL: 'Total*',
  PLUS_GST: 'plus GST',
  DISCOUNTS: 'Discounts',
  MONTHLY_DISCOUNT: 'Monthly discount',

  SETUP_FEE: 'Set up fee',
  DISCOUNT: 'discount',

  PRICING_DISCLAIMER: '*Actual pricing may vary monthly dependent on number of employees and pay cycles at a rate of $1.99 per employee, per pay cycle.',
  PROMO_CODE: 'Promo code',
  APPLY_CODE: 'Apply code',
  PROMO_CODE_PLACEHOLDER: 'Enter code',
  PROMO_CODE_SOMETHING_WENT_WRONG: 'Something went wrong, please try again.',

  REFERRAL_CODE: 'Please enter referral code',
  REFERRAL_CODE_PLACEHOLDER: 'Enter referral code',

  // Pick a plan
  SELECT_A_PLAN: 'Select a plan for your company',
  CREDIT_CHECK_WARNING: 'Based on the bank you’ve selected, you can automate your payroll deductions using our direct debit service where wages and tax amounts will be debited from your account two business days before pay day. You will need to consent to a credit check to use this service.',
  PLAN_EXTRAS: 'Plan extras',
  HIDE_FEATURES: 'Hide features',
  SHOW_FEATURES: 'See features',
  ERROR_CHOSEN_PLAN: 'Please select a plan',
  ERROR_NO_REFERRAL_CODE: 'Please enter a referral code',

  // Contact details
  CONTACT_DETAILS: 'Contact details',
  CLIENT_DETAILS: 'Primary contact details',
  PRIMARY_CONTACT_PERSON: 'This person will be the primary contact during the setup phase',
  I_AM_ACCOUNTANT: 'I am an accountant signing up on behalf of my client',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  JOB_TITLE: 'Job title',
  JOB_OTHER: 'Please specify',
  JOB_OTHER_PLACEHOLDER: 'Your job title',
  EMAIL_ADDRESS: 'Email address',
  PREFERRED_CONTACT_NUMBER: 'Preferred contact number',

  ERROR_FIRST_NAME: 'Please enter your first name',
  ERROR_LAST_NAME: 'Please enter your last name',
  ERROR_JOB_TITLE: 'Please select a job title',
  ERROR_JOB_OTHER: 'Please specify your job title',
  ERROR_EMAIL_ADDRESS: 'Please enter your email address',
  ERROR_CONTACT_NUMBER: 'Please enter your contact number',
  ERROR_FIRST_NAME_ADDITIONAL: 'Please enter the additional contact\'s first name',
  ERROR_LAST_NAME_ADDITIONAL: 'Please enter the additional contact\'s last name',
  ERROR_JOB_TITLE_ADDITIONAL: 'Please select the additional contact\'s job title',
  ERROR_JOB_OTHER_ADDITIONAL: 'Please specify the additional contact\'s job title',
  ERROR_EMAIL_ADDRESS_ADDITIONAL: 'Please enter the additional contact\'s address',
  ERROR_CONTACT_NUMBER_ADDITIONAL: 'Please enter the additional contact\'s contact number',

  ADD_ANOTHER_CONTACT: 'Add another contact (Optional)',
  ADDITIONAL_CONTACT: 'Additional contact',
  ADDITIONAL_ACCOUNT_CONTACT: 'Additional account contact or enter your clients’ details (if you prefer for us to contact the client directly)',

  REMOVE_CONTACT: 'Remove contact',

  PRIMARY_CONTACT_CHECKBOX: 'Make this person the primary contact',

  // Company details
  COMPANY_DETAILS: 'Company details',
  REGISTERED_COMPANY: 'Registered company name or sole trader details',
  PLACEHOLDER_REGISTERED_COMPANY: 'Enter company name',
  TRADING_NAME: 'Trading as name (optional)',
  PLACEHOLDER_TRADING_NAME: 'Enter trading as name',
  BUSINESS_IRD: 'Business/entity IRD number',
  PLACEHOLDER_IRD: 'e.g. 12-1234-125',
  INDUSTRY_TYPE: 'Industry type',
  CHARITY_REGISTRATION_NUMBER: 'Charity registration number',

  ERROR_REGISTERED_COMPANY: 'Please enter the registered company name',
  ERROR_BUSINESS_IRD: 'Please enter the business IRD number',
  ERROR_INDUSTRY_TYPE: 'Please enter the industry type',
  ERROR_CHARITY_REGISTRATION_NUMBER: 'Please enter your charity registration number',

  BUSINESS_ADDRESS: 'Business address',
  ADDRESS_FINDER: 'Address finder',
  START_TYPING_ADDRESS: 'Start typing the first line of your address',
  ENTER_ADDRESS_MANUAL: 'Enter address manually',
  HIDE_ADDRESS_MANUAL: 'Hide manual address',
  ADDRESS_LINE_ONE: 'Address line 1',
  ADDRESS_LINE_TWO: 'Address line 2',
  CITY: 'City',
  CITY_NO_RESULTS: 'Please check your spelling or request a callback if you cannot find the city',
  POST_CODE: 'Post code',
  REGION: 'Region',
  COUNTRY: 'Country',

  ERROR_BUSINESS_ADDRESS: 'Please search for your business address otherwise enter it manually',
  ERROR_POSTAL_ADDRESS: 'Please search for your postal address otherwise enter it manually',
  ERROR_ADDRESS_LINE_ONE: 'Please enter the address',
  ERROR_CITY: 'Please enter the city',
  ERROR_POST_CODE: 'Please enter the post code',
  ERROR_REGION: 'Please enter the region',
  ERROR_COUNTRY: 'Please enter the country',

  POSTAL_ADDRESS: 'Postal address',
  SAME_AS_BUSINESS: 'Same as business address',

  ACCOUNTANT_DETAILS: 'Accountant details',
  SELECT_YOUR_ACCOUNTANT: 'Select your accountant',
  START_TYPING_ACCOUNTANT: 'Start typing your accountant\'s business name',
  ACCOUNTANT_NOT_LISTED: 'My accountant is not listed',
  ACCOUNTANT_HIDE_MANUAL: 'Hide manual accountant fields',
  GIVE_ACCOUNTANT_PERMISSION: 'I give permission for my accountant to have access to',
  ACCOUNTANT_NAME: 'Accountant name',
  ACCOUNTANT_FIND_YOURSELF: 'Start typing to find your business name in the search box',

  ACCOUNTANT_NAME_FIRST_PERSON: 'Your name',
  SELECT_YOUR_ACCOUNTANT_FIRST_PERSON: 'Your business name',
  ACCOUNTANT_NOT_LISTED_FIRST_PERSON: 'My business is not listed',
  ACCOUNTANT_HIDE_MANUAL_FIRST_PERSON: 'Hide manual business fields',
  ERROR_SELECT_YOUR_ACCOUNTANT_FIRST_PERSON: 'Please find your business name from the list',
  START_TYPING_ACCOUNTANT_FIRST_PERSON: 'Start typing to find your business name',
  ENTER_ACCOUNTANT_NAME_FIRST_PERSON: 'Enter your name',
  ERROR_ACCOUNTANT_NAME_FIRST_PERSON: 'Please enter your name',
  ERROR_ACCOUNTANT_BUSINESS_NAME_FIRST_PERSON: 'Please enter your business name',
  ENTER_ACCOUNTANT_BUSINESS_NAME_FIRST_PERSON: 'Enter your business name',
  ACCOUNTANT_PHONE_NUMBER_FIRST_PERSON: 'Your contact phone number',
  ENTER_ACCOUNTANT_PHONE_NUMBER_FIRST_PERSON: 'Enter your contact phone number',
  ERROR_ACCOUNTANT_PHONE_NUMBER_FIRST_PERSON: 'Please enter your contact phone number',
  GIVE_ACCOUNTANT_PERMISSION_FIRST_PERSON: 'As the accountant I need access to',
  ERROR_GIVE_ACCOUNTANT_PERMISSION_FIRST_PERSON: 'Please select what you need access to',
  I_DO_NOT_HAVE_AN_ACCOUNTANT: 'I do not have an accountant/I do not know who our accountant is',

  ACCOUNTANT_TO_PAY_ON_BEHALF: 'I will pay the SmartPayroll fees on behalf of my customer',
  ADD_CUSTOMER_TO_MY_UMBRELLA: 'Please add this customer to my umbrella page',
  UMBRELLA_PAGE_USERNAME: 'Umbrella page username',
  ENTER_UMBRELLA_USERNAME: 'Enter umbrella username',
  ACCOUNTANT_PHONE_NUMBER: 'Accountant’s contact phone',
  ACCOUNTANT_BUSINESS_NAME: ' Accountant’s business name',
  ENTER_ACCOUNTANT_NAME: 'Enter name',
  ENTER_ACCOUNTANT_PHONE_NUMBER: 'Accountant’s contact phone',

  ERROR_ACCOUNTANT_BUSINESS_NAME: 'Please enter your accountant’s business name',
  ERROR_ACCOUNTANT_PHONE_NUMBER: 'Please enter your accountant’s contact phone number',
  ERROR_SELECT_YOUR_ACCOUNTANT: 'Please select your accountant from the list',
  ERROR_GIVE_ACCOUNTANT_PERMISSION: 'Please select the accountant\'s access level',
  ERROR_ACCOUNTANT_NAME: 'Please enter the accountant\'s name',
  ERROR_UMBRELLA_PAGE_USERNAME: 'Please enter your umbrella username',

  // Payroll information
  PAYROLL_INFORMATION: 'Payroll information',
  PAYROLL_TEXT: 'We need this information for your bank authorisation documents to make payments to employees and IRD on your behalf. This information is also used to debit your SmartPayroll fees on the 15th of each month.',
  SMART_PAYROLL_DIRECT_DEBIT_DISCLAIMER: 'Monthly fees must be paid by direct debit, and will be deducted on the 15th of each month.',
  BANK: 'Bank',
  BANK_IS_READONLY: 'If you need to change your bank selection, head back to Step 1 - Work it out',

  BANK_ACCOUNT_NAME: 'Bank account name',
  BANK_ACCOUNT_NUMBER: 'Bank account number',
  DIRECT_DEBIT: 'Direct debit',
  AUTHORISE_SMART_PAYROLL_TO_DIRECT_DEBIT_FEES: 'I have sole signing authority on this bank account and do not need to jointly authorise debits, I understand that this authority is subject to the terms relating to my bank account and have read and agree to the specific direct debit terms that relate to this authority',
  NOT_AUTHORISED_TO_DIRECT_DEBIT_FEES: 'I do not have sole authority, I request a Direct Debit Authority form',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  PROCESSING_PAYROLL: 'How are you currently processing payroll?',
  PAYE_PAYMENTS_TO_IRD: 'How often do you make PAYE payments to IRD?',
  EMPLOYEE_LEAVE_ROLLOVER: 'When does your employee’s annual leave rollover?',
  AVERAGE_GROSS_AMOUNT_PER_PAY_RUN: 'What is your average gross amount per pay run?',
  PAYROLL_PROCESSING_START: 'When would you like to run your first pay with SmartPayroll?',
  PAYROLL_PROCESSING_START_PLACEHOLDER: 'Enter date in format DD/MM/YYYY e.g. 26/05/2021',
  PAYROLL_OTHER_PAYROLL_SOFTWARE: 'Who is your current payroll provider?',

  ERROR_BANK_ACCOUNT_NAME: 'Please enter the bank account name',
  ERROR_BANK_ACCOUNT_NUMBER: 'Please enter the bank account number',
  ERROR_PROCESSING_PAYROLL: 'Please enter how you process payroll',
  ERROR_PROCESSING_OTHER_PAYROLL_SOFTWARE: 'Please specify the software you process your payroll with',
  ERROR_PROCESSING_PAYROLL_NO_RESULTS: 'You can also select "Other" and type in how you currently process payroll',
  ERROR_PAYE_PAYMENTS_TO_IRD: 'Please enter the frequency of PAYE payments to IRD you make',
  ERROR_EMPLOYEE_LEAVE_ROLLOVER: 'Please enter the employee leave rollover',
  ERROR_PROCESSING_START: 'Please enter your preferred first pay with SmartPayroll',
  ERROR_AVERAGE_GROSS_AMOUNT_PER_PAY_RUN: 'Please enter your average gross amount per pay run',

  // Summary step
  SUMMARY_TEXT: 'Please confirm this information is correct before continuing',
  ACCOUNTANT: 'Accountant',
  ADD_CUSTOMER_TO_UMBRELLA_PAGE: 'Add customer to umbrella page',
  FREQUENCY_OF_PAYE_PAYMENTS_TO_IRD: 'Frequency of PAYE payments to IRD',
  AUTHORISE_DIRECT_DEBITS_FOR_MONTHLY_FEES: 'Authorise direct debits for monthly fees',
  ADDITIONAL_COMMENTS: 'Additional comments (optional)',
  ADDITIONAL_COMMENTS_PLACEHOLDER: 'I.e. any training requirements',
  HOW_DID_YOU_HEAR_ABOUT_US: 'How did you hear about us?',
  HOW_DID_YOU_HEAR_ABOUT_US_OTHER: 'Please advise other way you heard about us',
  SEND_ME_INFORMATION: 'Send me information about special events / customer seminars / news and special offers',
  READ: 'Read',
  PRIVACY_POLICY: 'Privacy policy',
  PRIMARY_CONTACT: ' - (Primary)',

  REQUESTING_DD_FORM: 'Requesting a Direct Debit Authority form',
  ACCOUNTANT_WILL_PAY: 'Accountant to pay SmartPayroll fees on behalf of customer',

  ERROR_HOW_DID_YOU_HEAR_ABOUT_US: 'Please let us know how you heard about us',
  ERROR_HOW_DID_YOU_HEAR_ABOUT_US_OTHER: 'Please let us know what other way you heard about us',

  ERROR_SUBMIT_FAILED_TITLE: 'Something went wrong',
  ERROR_SUBMIT_FAILED_TEXT: 'Please check your input and try to submit again, if your problems persist, try refreshing the website',

  // Discounts
  MONTHLY_BASE_FEE_DISCOUNT: 'Monthly base fee discount',
  CHARITY_DISCOUNT: 'Charity monthly base fee discount',

  // Callback request
  CALLBACK_REQUEST_TITLE: 'Request callback',
  CALLBACK_REQUEST_SUBTITLE: 'Enter your contact details and we will get back to you.',
  CALLBACK_REQUEST_SUCCESS_TITLE: 'We have successfully received your details',
  CALLBACK_REQUEST_SUCCESS_SUBTITLE: 'A member of our team will be in contact with you shortly to assist you with your enquiry.',
  CALLBACK_REQUEST_FAIL_TITLE: 'We could not schedule a call',
  CALLBACK_REQUEST_FAIL_SUBTITLE: 'Sorry our callback request is not currently available. Please try again later.',
  FULL_NAME: 'Full name',
  ENTER_FULL_NAME: 'Enter full name',
  CALL_ME_BACK: 'Call me back',

  ERROR_FULL_NAME: 'Please enter your full name',

  // Next steps
  NEXT_STEPS: 'Next steps',
  GETTING_YOU_SET_UP: 'Getting you set up',
  GETTING_YOU_SET_UP_ACCOUNTANT: 'Getting your client set up',

  FIRST_STEP_TITLE: 'We’ll be in touch',
  FIRST_STEP_TEXT: 'Our Account Services team will call you within the next business day to get your business set up on SmartPayroll and discuss any training you require.',
  FIRST_STEP_TEXT_ACCOUNTANT: 'Our Account Services team will call you within the next business day to get this business set up on SmartPayroll and discuss any training required.',

  SECOND_STEP_TITLE: 'Then we’ll send you an email',
  SECOND_STEP_TEXT: 'We\'ll then send you an email with your login details so you can start setting your employees up.',
  SECOND_STEP_TEXT_AUTOMATIC: 'We\'ll then send you an email with your login details so you can start setting your employees up. We\'ll also send some documents for you to sign and return.',
  SECOND_STEP_TEXT_ACCOUNTANT: 'We\'ll then send you an email with login details so you and your client can start setting their employees up.',
  SECOND_STEP_TEXT_ACCOUNTANT_AUTOMATIC: 'We\'ll then send you an email with login details so you and your client can start setting their employees up. We\'ll also send some documents for your client to sign and return.',

  THIRD_STEP_TITLE: 'Get started',
  THIRD_STEP_TEXT: 'Once your employees are set up, you can use SmartPayroll for your next pay run.',

  THIRD_STEP_TITLE_AUTOMATIC: 'Complete the necessary documents and get started',
  THIRD_STEP_TEXT_AUTOMATIC: 'Once your employees are set up, you can use SmartPayroll for your next pay run. However, to start automating payments to employees, the IRD and other parties we will need to receive all signed documents and get confirmation from your bank that we can start automating payments. We will confirm with you when bank confirmation has been received. This usually takes up to 5 days or for ASB banking customers around 2 weeks.',

  THIRD_STEP_TEXT_ACCOUNTANT: 'Once their employees are set up, you or your client can use SmartPayroll for their next pay run.',
  THIRD_STEP_TEXT_ACCOUNTANT_AUTOMATIC: 'Once their employees are set up, you or your client can use SmartPayroll for their next pay run. However, to start automating payments to employees, the IRD and other parties we will need to receive all signed documents and get confirmation from your client\'s bank that we can start automating payments. We will confirm with you when bank confirmation has been received, this usually takes up to 5 days or for ASB banking customers around 2 weeks.',
};
